// NOTE: THESE MUST STAY IN SYNC
import styled, { css } from 'styled-components';
import { ScreenWidth, Spacing } from 'web-common/src/shared/styles';
import { minScreen } from 'web-common/src/shared/utils/StyledComponentUtils';

// Note: This makes more sense in my mind to keep as a styled component
export const CarouselRow = styled.div<{
  padding?: number;
  shadowBreathingRoom?: number;
  fullWidth?: boolean;
}>`
  width: 100%;
  ${({ fullWidth, shadowBreathingRoom = 0 }) =>
    !fullWidth &&
    css`
      ${minScreen(ScreenWidth.MEDIUM)} {
        width: calc(100% + ${shadowBreathingRoom * 2}px);
        margin-right: -${shadowBreathingRoom}px;
        margin-left: -${shadowBreathingRoom}px;
      }
    `};

  display: flex;
  align-items: center;
  justify-content: flex-start;

  overflow-x: scroll;
  overflow-y: clip;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }

  scroll-snap-type: x mandatory;
  scroll-padding-left: ${({ shadowBreathingRoom = 0 }) => shadowBreathingRoom}px;
  & > * {
    scroll-snap-align: start;
  }
  @media (max-width: ${ScreenWidth.MEDIUM}) {
    scroll-padding-left: ${({ padding = 0 }) => padding}px;
  }
  @media (max-width: ${ScreenWidth.SMALL}) {
    scroll-snap-type: none;
  }

  // Give box shadows breathing room at the bottom of this scrollable div
  padding-bottom: 50px;
  margin-bottom: -50px; // Prevent this from affecting anything outside the component

  & > * {
    opacity: 1;
    transition: opacity 0.11s ease-in-out;

    margin-right: ${Spacing.SINGLE};
    ${minScreen(ScreenWidth.SMALL)} {
      margin-right: ${Spacing.SINGLE_HALF};
    }
  }
  .offscreen {
    opacity: 0;
  }

  & > :first-child {
    margin-left: ${({ padding = 0 }) => padding}px;
    ${minScreen(ScreenWidth.MEDIUM)} {
      margin-left: ${({ shadowBreathingRoom = 0 }) => shadowBreathingRoom}px;
    }
  }
  & > :last-child {
    margin-right: ${({ padding = 0 }) => padding}px;
    ${minScreen(ScreenWidth.MEDIUM)} {
      margin-right: ${({ shadowBreathingRoom = 0 }) => shadowBreathingRoom}px;
    }
  }
`;
